import { Component, Input, Output, EventEmitter, ViewChildren, AfterViewChecked } from '@angular/core';
import { FileInfo, UploadComponent, FileState } from '@progress/kendo-angular-upload';
import { FormDialogTemplate } from './form-dialog.template';
import { CgpConfirmationDialogService } from '../cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'form-dialog',
    templateUrl: './form-dialog.component.html',
    styleUrls: ['./form-dialog.component.scss'],
    host: { 'class': 'dialog-window' },
})
export class FormDialogComponent implements AfterViewChecked {
    constructor(
        private cgpConfirmationDialogService: CgpConfirmationDialogService,
        private formBuilder: FormBuilder,
    ) {
        this.customForm = this.formBuilder.group({ customControl: [] });
    }

    @ViewChildren('input') vc;
    ngAfterViewChecked(): void {
        if (this.canShow()) this.focusFirst();
    }

    @Input()
    set template(obj: FormDialogTemplate) {
        this.dialogTemplate = obj;
    }

    @Output()
    cancel: EventEmitter<any> = new EventEmitter();

    @Output()
    save: EventEmitter<any> = new EventEmitter();

    initialized: boolean;
    actionFormDialog: any = undefined;
    panelBarControlSelectedItem: any = undefined;
    isActionFormDialogNew: boolean;
    commentFile: any;
    customForm: FormGroup;
    dialogTemplate: FormDialogTemplate;

    focusFirst() {
        if (this.initialized) return;
        try {
            try {
                this.vc.first.nativeElement.focus();
            } catch (e) { this.vc.first.focus() }
        } catch (e) { }
        finally { this.initialized = true }
    }

    isShowControl = (control: any, check: string = undefined, editForm: any = undefined): boolean => {
        try {
            const form: any = editForm ? editForm : this.dialogTemplate.editForm;
            return (check ? control.type === check : true) &&
                form.controls[control.name] !== undefined;
        } catch (e) {
            return false;
        }
    }


    getTitle = (): string => {
        let title: string = this.dialogTemplate.isNew ? 'Add New ' : 'Edit ';
        try {
            if (typeof this.dialogTemplate.title === 'string') {
                title += this.dialogTemplate.title
            } else if (this.dialogTemplate.title && this.dialogTemplate.title.value) {
                title = this.dialogTemplate.title.value;
            }
        } catch (e) { }
        return title;
    }


    getControlClass = (control: any, form: any) => {
        const ctrl = this.dialogTemplate.editForm.get(control.name);
        if (this.isShowControl(control, null, form)) {
            let formClass = '';
            if (control.stretch) formClass += 'stretch ';
            if (control.class) formClass += control.class + ' ';
            if (!control.stretch && this.dialogTemplate.largeForm) formClass += 'flex-column ';
            if (control.type !== "radiogroup" && control.type !== "grid") formClass += (this.dialogTemplate.inline || control.type === 'boolean') ? 'k-form-inline ' : 'k-form ';
            if (ctrl && ctrl.disabled) formClass += 'disabled';
            return formClass;
        }
        return 'hidden';
    }

    getLabelClass = (obj: any): string => {
        let response = 'cgp-blue';
        if (obj) {
            switch (obj.flag) {
                case 'error':
                case 'warning':
                case 'danger':
                    response = 'cgp-red info-text';
                    break;
                case 'info':
                    response = 'secondary-blue info-text';
                    break;
            }
        }
        return response;
    }

    getInputClass = (control: any) => {
        const ctrl = this.dialogTemplate.editForm.controls[control.name];
        const valid = ctrl.valid ? ' ng-valid' : ' ng-invalid';
        const touched = ctrl.touched ? ' ng-touched' : ' ng-untouched';
        const value = ctrl.value ? ' ng-not-empty' : '';
        const type = control.type === 'person' ? ' search' : '';
        return `modelo-text-input${valid}${touched}${value}`;
    }

    getTextAreaClass = (control: any) => {
        const ctrl = this.dialogTemplate.editForm.controls[control.name];
        const valid = ctrl.valid ? ' ng-valid' : ' ng-invalid';
        const touched = ctrl.touched ? ' ng-touched' : ' ng-untouched';
        const value = ctrl.value ? ' ng-not-empty' : ' ng-empty';
        return `textarea ${valid}${touched}${value}`;

    }

    canShow = (): boolean => {
        return this.dialogTemplate && this.dialogTemplate.value;
    }


    handleFilter = (e: any, control: any) => {
        const currentValue = this.dialogTemplate.editForm.value[control.name]
        if (control.service && control.service.handleFilter) {
            control.service.handleFilter(e, control.textField, currentValue);
        }
    }

    handleTabSelect = (e) => {
        this.dialogTemplate.selectTab(e.index);
    }

    handleGridControlCancel = ({ sender, rowIndex }) => sender.closeRow(rowIndex);

    isRequired = (c: any): boolean => {
        const ctrl = this.dialogTemplate.editForm.get(c.name);
        return ctrl.invalid;
    }

    private isStateValid(state: string): boolean {
        const _state: string = state ? state : "";
        switch (_state.toLowerCase()) {
            case 'update':
            case 'edit':
                return !this.dialogTemplate.isNew;
            case 'add':
            case 'create':
            case 'new':
                return this.dialogTemplate.isNew;
            default:
                return true;
        }
    }

    isShowFooterLabel = (): boolean => {
        return this.dialogTemplate.footerLabel;
    }

    isShowNotificationLabel = (): boolean => {
        const c = this.dialogTemplate.notificationLabel;
        return c && this.isStateValid(c.state);
    }

    getCustomForm(file: any, name: string): FormGroup {
        if (!file.form) file.form = this.formBuilder.group({ comment: ['', Validators.compose([Validators.required, Validators.maxLength(255)])] });
        return file.form
    }


    onUploadComment = (control: any, file: any) => {
        if (control.comment) {
            file[0].form.reset(file);
        }
    }


    onCommentSave = (control: any, files: any[], form: FormGroup, c: UploadComponent) => {
        files[0].comment = files[0].form.get("comment").value;
        delete files[0].form;
        if (control.save) {
            control.save(files, form, c);
            files[0].state = FileState.Initial;
        }
    }


    onCommentCancel = (file: FileInfo, c: UploadComponent, control: any) => {
        c.fileList.remove(file.uid);
        if (control.cancel) control.cancel(file, c);
    };


    getValue = (control: any): string => {
        const response: string = control.value ? control.value :
            this.dialogTemplate.editForm.controls[control.name].value;
        return response;
    }

    onSave(e, isSubmit: boolean): void {
        e.preventDefault();

        if (isSubmit) {

            this.cgpConfirmationDialogService.showConfirmationDialog({
                title: 'Submit Confirmation',
                message: 'Are you sure that you want to submit this request?',
                alert: 'warning',
                onYesClick: () => {
                    this.handleSave(true)
                    this.cgpConfirmationDialogService.closeConfirmationDialog();
                },
                onNoClick: () => {
                    this.cgpConfirmationDialogService.closeConfirmationDialog();
                }
            });
        } else {
            this.handleSave();
        }
    }

    onCancel(e): void {
        e.preventDefault();
        this.closeForm();
    }


    closeForm(): void {
        this.dialogTemplate.next(null);

        if (this.dialogTemplate.cancel) {
            this.dialogTemplate.cancel();
        }
        this.cancel.emit();
    }


    isDisabled(state: string): boolean {
        return state === 'always' ||
            state === 'create' && this.dialogTemplate.isNew ||
            state === 'update' && !this.dialogTemplate.isNew;
    }


    private handleSave(isSubmit = false) {

        this.dialogTemplate.next(null);
        this.dialogTemplate.editForm.enable();

        if (this.dialogTemplate.save) {
            this.dialogTemplate.save({
                dataItem: this.dialogTemplate.editForm.value,
                isNew: this.dialogTemplate.isNew,
                isSubmit
            });
        }

        this.save.emit({ dataItem: this.dialogTemplate.editForm.value, isNew: this.dialogTemplate.isNew, isSubmit: isSubmit });
    }



}
